/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs */

const en_admin_external_booking_edit_discount_removed_for_resource = /** @type {(inputs: Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The discount code is not valid for the selected resource and has been removed.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs) => LocalizedString} */
const de_admin_external_booking_edit_discount_removed_for_resource = en_admin_external_booking_edit_discount_removed_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs) => LocalizedString} */
const es_admin_external_booking_edit_discount_removed_for_resource = en_admin_external_booking_edit_discount_removed_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs) => LocalizedString} */
const fr_admin_external_booking_edit_discount_removed_for_resource = en_admin_external_booking_edit_discount_removed_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs) => LocalizedString} */
const it_admin_external_booking_edit_discount_removed_for_resource = en_admin_external_booking_edit_discount_removed_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_discount_removed_for_resource = en_admin_external_booking_edit_discount_removed_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs) => LocalizedString} */
const pl_admin_external_booking_edit_discount_removed_for_resource = en_admin_external_booking_edit_discount_removed_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs) => LocalizedString} */
const hu_admin_external_booking_edit_discount_removed_for_resource = en_admin_external_booking_edit_discount_removed_for_resource;

/** @type {(inputs: Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs) => LocalizedString} */
const ro_admin_external_booking_edit_discount_removed_for_resource = en_admin_external_booking_edit_discount_removed_for_resource;

/**
* | output |
* | --- |
* | "The discount code is not valid for the selected resource and has been removed." |
*
* @param {Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_discount_removed_for_resource = /** @type {((inputs?: Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Discount_Removed_For_ResourceInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_discount_removed_for_resource(inputs)
	if (locale === "de") return de_admin_external_booking_edit_discount_removed_for_resource(inputs)
	if (locale === "es") return es_admin_external_booking_edit_discount_removed_for_resource(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_discount_removed_for_resource(inputs)
	if (locale === "it") return it_admin_external_booking_edit_discount_removed_for_resource(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_discount_removed_for_resource(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_discount_removed_for_resource(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_discount_removed_for_resource(inputs)
	return ro_admin_external_booking_edit_discount_removed_for_resource(inputs)
});
export { admin_external_booking_edit_discount_removed_for_resource as "admin.external_booking_edit.discount_removed_for_resource" }